import React, { useState, useEffect } from "react";
import DataTable from "../shared/DataTable";
import { useLocation, useNavigate } from "react-router-dom";
import { useBreadcrumb } from "../../context/BreadcrumbContext";

const PipeAnalysisType = () => {
  const { setAnalysisSubType } = useBreadcrumb();
  const navigate = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    setAnalysisSubType(loc.state?.type || "");
  }, [loc.state?.type, setAnalysisSubType]);

  useEffect(() => {
    if (!loc.state) {
      navigate('/dashboard', { replace: true });
    }
  }, [loc.state, navigate]);

  const [headerName, setHeaderName] = useState("");
  const [tableHeader, setTableHeader] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectedButton, setSelectedButton] = useState("");
  const [apiData, setApiData] = useState(null);

  const location = useLocation();
  const { pipeData } = location.state || {};


  useEffect(() => {
    const savedButton = localStorage.getItem("selectedButton");
    if (savedButton) {
      setSelectedButton(savedButton);
    }


    return () => {
      if (!window.location.href.includes('/dashboard/drawing')) {
        localStorage.removeItem("selectedButton");
      }
    };
  }, []);

  useEffect(() => {
    const handlePopState = () => {
      if (!window.location.href.includes('/dashboard/drawing')) {
        localStorage.removeItem("selectedButton");
      }
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  useEffect(() => {
    if (pipeData && pipeData.overlay && pipeData.overlay.hookData && pipeData.overlay.hookData.data) {
      setApiData(pipeData.overlay.hookData.data);
    }
  }, [pipeData]);

  useEffect(() => {
    if (selectedButton && apiData) {
      handleBoxClick(selectedButton);
    }
  }, [apiData, selectedButton]);

  const staticHeaders = {
    name: "Hook ID",
    pipeSize: "Pipe Size",
    pipeLookupCapacity: "Pipe Capacity (TR)",
    loadBalance: "Load (TR)",
    issues: "Issues",
    description: "Description",
  };

  const handleBoxClick = (label) => {
    if (apiData && apiData[label.toLowerCase()]) {
      const selectedData = apiData[label.toLowerCase()];
      setHeaderName(label);

      const headers = Object.keys(staticHeaders).map((key) => staticHeaders[key]);
      setTableHeader(headers);

      const mappedData = selectedData.data.map((item, index) => {
        const newItem = {};
        Object.keys(staticHeaders).forEach((key) => {
          if (key === "name") {
            newItem[staticHeaders[key]] = item.name || item.hookName || "";
            newItem.imageURL = item.overlay?.imageURL || item.imageURL || "";
          } else if (key === "issues") {
            newItem[staticHeaders[key]] = "Load Imbalance";
          } else if (key === "description") {
            if (item.pipeLookupCapacity !== item.loadBalance) {
              newItem[staticHeaders[key]] = "Load Imbalance Between Pipe Capacity and Load";
            } else {
              newItem[staticHeaders[key]] = "No Safety Factor Between Pipe Capacity and Load";
            }
          } else {
            newItem[staticHeaders[key]] = item[key] || "";
          }
        });

        newItem.isMailSent = item.isMailSent || false;
        newItem.sentEmailData = item.sentEmailData || [];

        if (!item.id) {
          newItem.id = `${label.toLowerCase()}-${index}`;
        } else {
          newItem.id = item.id;
        }

        return newItem;
      });
      setTableData(mappedData);
      setSelectedButton(label);
      setAnalysisSubType(label);
      localStorage.setItem("selectedButton", label);
    }
  };

  const renderButtons = () => {
    if (!apiData) return null;

    const labels = Object.keys(apiData).map((key) => key.toUpperCase());

    return (
      <div className="tab-container" style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
        {labels.map((label) => {
          const item = apiData[label.toLowerCase()];

          let buttonColor = "lightgray";
          let isDisabled = false;
          if (item) {
            if (item.issues > 0) {
              buttonColor = "#fa6e33";
            } else if (item.issues === 0 && item.noIssues > 0) {
              buttonColor = "#50CD89";
            } else if (item.issues === 0 && item.noIssues === 0) {
              buttonColor = "lightgray";
              isDisabled = true;
            }
          }

          return (
            <button
              key={label}
              type="button"
              className="btn equipment-border"

              onClick={!isDisabled ? () => handleBoxClick(label) : undefined}
              style={{
                border: selectedButton === label ? "1px solid" : "none",
                backgroundColor: buttonColor,
                height: "35px",
                width: "80px",
                color: "white",
                cursor: isDisabled ? "default" : "pointer",
                fontSize: "14px"
              }}
              disabled={isDisabled}
            >
              {label}
            </button>
          );
        })}
      </div>
    );
  };

  return (
    <div className="container-fluid">
      <div className="row rounded mx-2 mb-4 theme-container">
        <div className="col-12 mt-2 p-4">{renderButtons()}</div>
      </div>
      {selectedButton && (
        <div className="row rounded mx-2 theme-container mt-4">
          <div className="col-12 p-4">

            <div className="table-responsive">
              <DataTable
                headingText={`${headerName} - Capacity Issues`}
                headers={tableHeader}
                data={tableData}
              />
            </div>

          </div>
        </div>
      )}
    </div>
  );
};

export default PipeAnalysisType;



